import { useEffect, useState } from 'react';
import axios from 'axios';
import { getApiBaseUrl } from '../utils/apiUrls';

const DEFAULT = {
  login: { twitter: false, telegram: false, discord: false },
  discord: { botConfigured: false, slashCommands: [] },
  escrow: { configured: false, adapterId: 'escrow_onchain' },
  settlement: { stablecoins: [], fiat: [], fiatConfigured: false, adapters: [] },
  beta: { linkCreation: true, onchainDepositClaim: false, fiatDepositClaim: false },
};

export function usePublicConfig() {
  const [config, setConfig] = useState(DEFAULT);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${getApiBaseUrl().replace(/\/$/, '')}/config/public`, { timeout: 12000 })
      .then((res) => {
        if (!cancelled && res.data) setConfig({ ...DEFAULT, ...res.data });
      })
      .catch(() => {
        if (!cancelled) setConfig(DEFAULT);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { config, loading };
}
